"use client";

import AutoScroll from "embla-carousel-auto-scroll";
import useEmblaCarousel from "embla-carousel-react";
import { webAssetsCdnBaseUrl } from "@/shared/constants";

export function SocialProofCarousel() {
  return (
    <div className="mx-auto w-full max-w-(--breakpoint-lg)">
      <div className="mx-auto flex max-w-(--breakpoint-lg) flex-col gap-6 px-8">
        <h3 className="text-center text-2xl sm:text-3xl">Trusted by teams at:</h3>
      </div>
      <div className="relative grid h-28 w-full overflow-hidden">
        <BaseCarousel />
      </div>
    </div>
  );
}

const names = [
  "meta",
  "nba",
  "loreal",
  "puma",
  "cisco",
  "deel",
  "shopify",
  "decathlon",
  "dallas-mavericks",
  "pittsburgh-pirates",
  "tala",
  "dyson",
  "dazn",
  "wsc-sports",
];

function BaseCarousel() {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, slidesToScroll: "auto" }, [
    AutoScroll({ playOnInit: true, direction: "backward", speed: 0.5 }),
  ]);

  return (
    <div className="absolute w-full">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className={"flex items-center px-4"}>
          {names.map((name) => {
            const baseUrl = `${webAssetsCdnBaseUrl}/products/trusted-by/${name}`;

            return (
              <picture className="min-w-40 max-w-40 px-8" key={name}>
                <source srcSet={`${baseUrl}.webp`} type="image/webp" />
                <img
                  src={`${baseUrl}.png`}
                  className="block rounded-md object-contain"
                  alt={`${name} logo`}
                />
              </picture>
            );
          })}
        </div>
      </div>
    </div>
  );
}
